if (!customElements.get('media-gallery')) {

  class ProductThumbnailVerticalSliderComponent extends SliderComponent {
    constructor() {
      super();

      this.isDragging = false;
      this.dragMoved = false;
      this._freezeScrollHandlers = false;
    }

    initPages() {
      this.isMobile = window.innerWidth < 750;

      if (this.isMobile) {
        super.initPages();
      } else {

        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
          (el) => el.clientHeight > 0
        );

        if (this.sliderItemsToShow.length < 2) return;

        this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetTop -
          this.sliderItemsToShow[0].offsetTop;

        this.slidesPerPage = Math.floor(
          (
            this.slider.clientHeight -
            this.sliderItemsToShow[0].offsetTop
          ) / this.sliderItemOffset
        );

        this.totalPages =
          this.sliderItemsToShow.length -
          this.slidesPerPage +
          1;

        this.update();
      }
    }

    updateFromScroll() {
      if (!this.sliderItemOffset || !this.totalPages) return;

      /* instant trigger */
      const triggerOffset = this.sliderItemOffset * 0.25;

      const newPage =
        Math.floor(
          (this.slider.scrollTop + triggerOffset) /
          this.sliderItemOffset
        ) + 1;

      const clampedPage = Math.max(
        1,
        Math.min(newPage, this.totalPages)
      );

      if (clampedPage === this.currentPage) return;

      this.currentPage = clampedPage;

      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement:
              this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    update() {
      if (this._freezeScrollHandlers) return;

      if (this.isMobile) {
        super.update();
      } else {

        const prevPage = this.currentPage;

        this.currentPage =
          Math.floor(
            (
              this.slider.scrollTop +
              this.sliderItemOffset * 0.25
            ) / this.sliderItemOffset
          ) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
          this.currentPageElement.textContent = this.currentPage;
          this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage !== prevPage) {

          this.dispatchEvent(
            new CustomEvent('slideChanged', {
              detail: {
                currentPage: this.currentPage,
                currentElement:
                  this.sliderItemsToShow[this.currentPage - 1],
              },
            })
          );
        }

        if (this.enableSliderLooping) return;

        if (
          this.isSlideVisible(this.sliderItemsToShow[0]) &&
          this.slider.scrollTop < 3
        ) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow.at(-1))) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }

    isSlideVisible(element, offset = 0) {
      if (this.isMobile) return super.isSlideVisible(element, offset);

      const lastVisible =
        this.slider.clientHeight +
        this.slider.scrollTop -
        offset;

      return (
        element.offsetTop + element.clientHeight <= lastVisible &&
        element.offsetTop >= this.slider.scrollTop
      );
    }

    onButtonClick(event) {

      if (this.isMobile) {
        super.onButtonClick(event);
      } else {

        event.preventDefault();

        const step =
          event.currentTarget.dataset.step || 1;

        const delta =
          event.currentTarget.name === 'next'
            ? step * this.sliderItemOffset
            : -step * this.sliderItemOffset;

        this.slider.scrollTo({
          top: this.slider.scrollTop + delta,
          behavior: 'smooth',
        });
      }
    }

    enableMouseDrag() {
      super.enableMouseDrag();

      this.slider
        .querySelectorAll('button')
        .forEach((el) =>
          el.setAttribute('draggable', 'false')
        );
    }

    onDragStart(e) {

      if (e.button !== 0) return;

      this.isDragging = true;
      this.dragMoved = false;

      this.startY = e.pageY;
      this.scrollStart = this.slider.scrollTop;

      this.slider.classList.add('is-dragging');
    }

    onDragMove(e) {

      if (!this.isDragging) return;

      const deltaY = e.pageY - this.startY;

      if (Math.abs(deltaY) > 2) {

        if (!this.dragMoved) {

          this.dragMoved = true;

          this.slider
            .querySelectorAll('a')
            .forEach((a) => {
              a.style.pointerEvents = 'none';
            });
        }

        e.preventDefault();

        /* direct tracking = no delay */
        this.slider.scrollTop =
          this.scrollStart - deltaY;

        /* instant sync */
        this.updateFromScroll();
      }
    }

    onDragEnd() {

      if (!this.isDragging) return;

      this.isDragging = false;

      this.slider
        .querySelectorAll('a')
        .forEach((a) => {
          a.style.pointerEvents = '';
        });

      this.slider.classList.remove('is-dragging');
    }
  }

  customElements.define(
    'product-thumbnail-vertical-slider-component',
    ProductThumbnailVerticalSliderComponent
  );

  customElements.define(
    'media-gallery',

    class MediaGallery extends HTMLElement {

      constructor() {

        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          navgiations: this.querySelector('[id^="SliderNavigations"]'),
        };

        this.mql =
          window.matchMedia('(min-width: 750px)');

        /* thumbnails */

        if (this.elements.thumbnails) {

          this.elements.viewer.addEventListener(
            'slideChanged',
            this.onSlideChanged.bind(this)
          );

          this.bindThumbnailButtons();

          const desktopLayout =
            this.dataset.desktopLayout || '';

          if (
            desktopLayout.includes('thumbnail') &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }

        /* nav */

        if (this.elements.navgiations) {

          this.elements.viewer.addEventListener(
            'slideChanged',
            this.onSlideChangedNavigation.bind(this)
          );

          this.elements.navgiations
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {

              mediaToSwitch.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );

            });
        }
      }

      connectedCallback() {
        updateProductMediaStatus(this);
      }

      onSlideChanged(event) {

        const thumbnail =
          this.elements.thumbnails?.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      onSlideChangedNavigation(event) {

        if (
          !event.detail.currentElement.dataset.mediaId
        ) return;

        const navItem =
          this.elements.navgiations?.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );

        this.setActiveNav(navItem);
      }

      bindThumbnailButtons() {

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {

            const button =
              mediaToSwitch.querySelector('button');

            if (!button) return;

            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );

          });
      }

      setActiveMedia(
        mediaId,
        prepend,
        allowScrollIntoView = true
      ) {

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        this.preventStickyHeader();

        requestAnimationFrame(() => {

          activeMedia.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });

        });

        /* thumbnails */

        if (this.elements.thumbnails) {

          const activeThumbnail =
            this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

          this.setActiveThumbnail(activeThumbnail);

          if (activeThumbnail) {

            this.announceLiveRegion(
              activeMedia,
              activeThumbnail.dataset.mediaPosition
            );
          }
        }

        /* nav */

        if (this.elements.navgiations) {

          const activeNav =
            this.elements.navgiations.querySelector(
              `[data-target="${mediaId}"]`
            );

          this.setActiveNav(activeNav);
        }
      }

    setActiveNav(navItem) {

      if (
        !this.elements.navgiations ||
        !navItem
      ) return;

      this.elements.navgiations
        .querySelectorAll('[data-target]')
        .forEach((element) => {

          element.classList.remove('is-active');

          element.removeAttribute('aria-current');
        });

      navItem.classList.add('is-active');

      navItem.setAttribute('aria-current', true);

      const navContainer = this.elements.navgiations;

      const navLeft = navItem.offsetLeft;
      const navWidth = navItem.offsetWidth;
      const containerWidth = navContainer.clientWidth;

      const targetScroll =
        navLeft - (containerWidth / 2) + (navWidth / 2);

      navContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });
    }

    setActiveThumbnail(thumbnail) {

      if (
        !this.elements.thumbnails ||
        !thumbnail
      ) return;

      this.elements.thumbnails
        .querySelectorAll('button')
        .forEach((element) =>
          element.removeAttribute('aria-current')
        );

      this.elements.thumbnails
        .querySelectorAll('[data-target]')
        .forEach((element) =>
          element.classList.remove('is-active')
        );

      thumbnail
        .querySelector('button')
        .setAttribute('aria-current', true);

      thumbnail.classList.add('is-active');

      const slider = this.elements.thumbnails.slider;

      if (
        slider.classList.contains('thumbnail-list--vertical') &&
        window.innerWidth >= 750
      ) {

        const thumbTop = thumbnail.offsetTop;
        const thumbHeight = thumbnail.offsetHeight;
        const containerHeight = slider.clientHeight;

        const targetScroll =
          thumbTop - (containerHeight / 2) + (thumbHeight / 2);

        slider.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
        });

      } else {

        const thumbLeft = thumbnail.offsetLeft;
        const thumbWidth = thumbnail.offsetWidth;
        const containerWidth = slider.clientWidth;

        const targetScroll =
          thumbLeft - (containerWidth / 2) + (thumbWidth / 2);

        slider.scrollTo({
          left: targetScroll,
          behavior: 'smooth',
        });
      }
    }

      announceLiveRegion(activeItem, position) {

        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );

        if (!image) return;

        image.onload = () => {

          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {

            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );

          }, 2000);

          addLoadedImageStatus(image);
        };

        image.src = image.src;
      }

      preventStickyHeader() {

        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {

        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach(
          (slide) =>
            slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}